export default "app-select-check-all .mat-checkbox-layout,\napp-select-check-all .mat-checkbox-label {\n  width:100% !important;\n}\n";